import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BUYER_CARD_BASE_URL } from '../config/settings/environment'

/**
 * Get Average Pay
 */
export const getAveragePay = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/pago_promedios/calculo_dias?rut=${dni}`)
})

/**
 * Get basic buyer information.
 */
export const getTotalPurchases = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/ficha/total_compras?rut=${dni}`)
})
